import { Button, makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { ARRIVAL_LIST } from '../../../constants/GuestInforConst';
import { selectedHotelSelector } from '../../property/propertySlice';
import ArrivalList from './arrival-list/ArrivalList';

const useStyles = makeStyles((theme) => ({
  activeButton: {
    color: '#29E67C',
    borderRadius: '26px',
    border: '2px solid #74E287',
    opacity: 1,
    fontWeight: 600,
    fontSize: '1.2em',
  },
  button: {
    borderRadius: '26px',
    fontWeight: 600,
    fontSize: '1.2em',
  },
  input: {
    display: 'none',
  },
}));

const GuestInformation = (props) => {
  const { permissions } = props;
  const [activeTab, setActiveTab] = useState(ARRIVAL_LIST);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const classes = useStyles();
  const selectedHotel = useSelector(selectedHotelSelector);

  useEffect(() => {
    if (activeTab === ARRIVAL_LIST) {
      setPage(0);
      setRowsPerPage(5);
    }
  }, [activeTab]);

  return (
    <div className='container mt-4'>
      <div className='row d-flex'>
        <div className='col-md-6'>
          <span className='page-title'>Guest Communication</span>
        </div>
      </div>
      <div className='row d-flex mt-4 accommodation-list'>
        <div className='d-flex flex-wrap'>
          <Button
            size='large'
            variant={activeTab === ARRIVAL_LIST ? 'outlined' : 'text'}
            className={
              activeTab === ARRIVAL_LIST ? classes.activeButton : classes.button + 'showpopup'
            }
            onClick={() => setActiveTab(ARRIVAL_LIST)}
          >
            Arrival List
          </Button>
        </div>
      </div>
      <div className='row mx-2 d-flex mt-4'>
        <div className='card shadow'>
          {activeTab === ARRIVAL_LIST && (
            <ArrivalList
              selectedHotel={selectedHotel}
              permissions={permissions}
              onsetPage={(e) => setPage(e)}
              page={page}
              onsetRowsPerPage={(e) => setRowsPerPage(e)}
              rowsPerPage={rowsPerPage}
            />
          )}
        </div>
      </div>
    </div>
  );
};

export default GuestInformation;
